import { render, staticRenderFns } from "./TrainCommon.vue?vue&type=template&id=dbc151b8&scoped=true&"
import script from "./TrainCommon.vue?vue&type=script&lang=js&"
export * from "./TrainCommon.vue?vue&type=script&lang=js&"
import style0 from "./TrainCommon.vue?vue&type=style&index=0&id=dbc151b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc151b8",
  null
  
)

export default component.exports